import { festivalFooterColor } from "@features/landing/helpers/constants/festival-colors";
import { FESTIVAL_TYPE } from "@features/landing/types";
import classNames from "classnames";
interface Props {
  theme: FESTIVAL_TYPE;
  description: string;
}

const FestivalFooter: React.FC<Props> = ({ theme, description }) => {
  return (
    <section
      className={classNames(festivalFooterColor[theme], "mb-16 py-7 relative")}
    >
      <div className="absolute top-0 left-0 right-0 bottom-0 z-0 opacity-40 bg-[url('https://faradars.org/wp-content/uploads/2024/04/30/festival-footer-pattern.svg')]" />
      <div
        className="max-w-[1280px] mx-auto px-6 relative z-3 text-center"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </section>
  );
};

export default FestivalFooter;
